module.exports = __webpack_public_path__ + "img/freestyle_box19.90123385.jpg";